/** Relative segments under the legal pages route. */
export const LEGAL_PAGES = {
  impressum: 'impressum',
  dataPrivacy: 'data-privacy',
  termsAndConditions: 'terms-and-conditions',
} as const;
export type LegalPage = keyof typeof LEGAL_PAGES;

const LEGALS = '/legals';

/** Absolute application routes; the single source for paths and links. */
export const ROUTES = {
  root: '/',
  home: '/home',
  userManagement: '/user-management',
  legals: LEGALS,
  legal: (page: LegalPage) => `${LEGALS}/${LEGAL_PAGES[page]}`,
} as const;
